export default __webpack_public_path__ + "static/media/kapok tree.5aa39337.jpg";